// TODO: Handle if the browser doesnt support locale storage. Use $cookies if not.
import { EVENTS } from '@shared/events';

class StorageService {
  constructor($cookies, EventDispatcherService) {
    'ngInject';
    this.$cookies = $cookies;
    this.supportsLocalStorage = false;
    
    if (EventDispatcherService) {
      EventDispatcherService.addListener(EVENTS.UNAUTHORIZED_ACCESS, event => this.clear());
    }
    
    try {
      let testKey = 'storage-test';
      localStorage.setItem(testKey, 'ok');
      localStorage.removeItem(testKey);
      this.supportsLocalStorage = true;
    } catch (e) {
      this.supportsLocalStorage = false;
    }
  }

  setItem(key, value) {
    if (this.supportsLocalStorage) {
      return localStorage.setItem(key, value);
    }
  }

  getItem(key) {
    if (this.supportsLocalStorage) {
      return localStorage.getItem(key);
    }
  }

  removeItem(key) {
    if (this.supportsLocalStorage) {
      return localStorage.removeItem(key);
    }
  }

  hasItem(key) {
      if (this.supportsLocalStorage) {
        if (this.getItem(key) !== null) {
          return true;
        }
      }

      return false;
  }

  clear() {
    if (this.supportsLocalStorage) {
      const donotShowGooglePromptModal = this.getItem('do-not-show-google-prompt');
      localStorage.clear();

      if (donotShowGooglePromptModal) {
        localStorage.setItem('do-not-show-google-prompt', donotShowGooglePromptModal);
      }
    }
  }

  removeZendeskCookie() {
    const zendeskCookieIndex = '__zlcmid';
    this.$cookies.remove(zendeskCookieIndex);
  }

  removeAllCookie() {
    const domain = window.location.hostname;
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i]
        let eqPos = cookie.indexOf("=");
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=" + domain;
    }
  }
}

export default StorageService;



// WEBPACK FOOTER //
// ./client/app/shared/storage.service.js